export const checkbox = {
  colorScheme: {
    light: {
      background: '{surface.100}',
      color: '{neutral.900}',
      borderColor: '#5B5F69',
    },
    dark: {
      background: '#333643',
      color: 'white',
    },
  },
};
